import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// /* eslint-disable max-lines */
import { all, call, put } from 'redux-saga/effects';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import AuthSagas from '../../redux/auth/sagas';
import ApiSagas from '../../redux/api/sagas';
import { redirect } from '../../helpers/UrlHelpers';
import { Router } from '../../routes';
import { actions as appActions } from '../../redux/app/redux';
import { actions as pageActions } from './redux';
import * as services from './services';
import { transformSeo } from './transformers';
var PageSagas = /*#__PURE__*/function () {
  function PageSagas() {
    _classCallCheck(this, PageSagas);
  }
  return _createClass(PageSagas, null, [{
    key: "init",
    value: function init(_ref) {
      var asPath = _ref.asPath,
        query = _ref.query,
        res = _ref.res,
        req = _ref.req;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              PageSagas.req = req;
              PageSagas.res = res;
              console.log({
                asPath: asPath
              });
              if (!(asPath.match('/_next/*') || asPath.match('/_webpack/*') || asPath.match('/__webpack_hmr*'))) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", {
                error: 404
              });
            case 1:
              if (!(asPath === '/home' || asPath === '/')) {
                _context.next = 3;
                break;
              }
              _context.next = 2;
              return call(AuthSagas.redirectLogged);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
              query.slug = query.slug ? Array.isArray(query.slug) ? query.slug.join('/') : query.slug : '';
              _context.next = 4;
              return call(PageSagas.loadPage, query, asPath, res);
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    }
  }, {
    key: "loadPage",
    value: function loadPage(_ref2) {
      var _ref2$slug = _ref2.slug,
        slug = _ref2$slug === void 0 ? '/' : _ref2$slug;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result, seoParams, seo;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return put(showLoading());
            case 1:
              if (Array.isArray(slug)) {
                slug = slug[0];
              }
              _context2.next = 2;
              return call(ApiSagas.query, services.pageBySlug, {
                slug: slug,
                localeFilters: {
                  locale: 'en'
                }
              });
            case 2:
              result = _context2.sent;
              if (!result.data) {
                _context2.next = 4;
                break;
              }
              seoParams = {
                title: result.data.title
              };
              _context2.next = 3;
              return call(transformSeo, result.data, seoParams);
            case 3:
              seo = _context2.sent;
              _context2.next = 4;
              return all([put(pageActions.setData(result.data)), put(appActions.setSeo(seo))]);
            case 4:
              _context2.next = 5;
              return all([put(pageActions.setLoaded(true)), put(hideLoading())]);
            case 5:
              if (result.data) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", {
                error: 404
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    }
  }, {
    key: "redirectToPage",
    value: function redirectToPage() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PageSagas.res;
      var destinationRoute = arguments.length > 1 ? arguments[1] : undefined;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return call(redirect, res, Router.getRouteUrl(destinationRoute), 303);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    }
  }, {
    key: "loop",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function loop() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return all([
              //
            ]);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, loop);
    })
  }]);
}();
_defineProperty(PageSagas, "req", null);
_defineProperty(PageSagas, "res", null);
export { PageSagas as default };